var React = require('react');

function Contentad (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".content-ad-icon-svg-1{fill:#ff4c32;}.content-ad-icon-svg-2{fill:#fff;}")),React.createElement("path",{"className":"content-ad-icon-svg-1","d":"M15.57,0H3.6A1.64,1.64,0,0,0,2,1.64v12A1.63,1.63,0,0,0,3.6,15.24H7.27V20l4.31-4.76h4a1.64,1.64,0,0,0,1.64-1.63v-12A1.65,1.65,0,0,0,15.57,0Z","key":1}),React.createElement("polygon",{"className":"content-ad-icon-svg-2","points":"13.61 6.85 10.44 6.85 10.44 3.69 8.73 3.69 8.73 6.85 5.57 6.85 5.57 8.56 8.73 8.56 8.73 11.73 10.44 11.73 10.44 8.56 13.61 8.56 13.61 6.85","key":2})]);
}

Contentad.defaultProps = {"id":"Layer_8","data-name":"Layer 8","viewBox":"0 0 20 20","width":"20","height":"20"};

module.exports = Contentad;

Contentad.default = Contentad;
